import { render, staticRenderFns } from "./AttributeStack.vue?vue&type=template&id=3f02d774&scoped=true&"
import script from "./AttributeStack.vue?vue&type=script&lang=js&"
export * from "./AttributeStack.vue?vue&type=script&lang=js&"
import style0 from "./AttributeStack.vue?vue&type=style&index=0&id=3f02d774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f02d774",
  null
  
)

export default component.exports